// Country lookup for the central call log (CDCSF-5447). Must run on the FULL
// number, before redactNumber() — the masked form loses the digits needed to
// tell e.g. US from Canada. Pure module so the browser client can bundle it.

const { parsePhoneNumberFromString } = require("libphonenumber-js");
const { normalise } = require("./redact");
const { COUNTRY_CENTROIDS } = require("./countryCentroids");

const PRECISION_COUNTRY = "country";
const PRECISION_UNKNOWN = "unknown";

/**
 * @param {string|null|undefined} raw full (unredacted) number
 * @param {{ defaultCountry?: string }} [options] ISO2 used for numbers without a "+"
 * @returns {{ country: string|null, lat: number|null, lng: number|null, precision: string }}
 */
function locateNumber(raw, { defaultCountry } = {}) {
  const unknown = { country: null, lat: null, lng: null, precision: PRECISION_UNKNOWN };
  if (raw === null || raw === undefined) return unknown;

  const normalised = normalise(raw);
  if (!normalised || /X/.test(normalised)) return unknown;

  let parsed;
  try {
    parsed = parsePhoneNumberFromString(normalised, defaultCountry || undefined);
  } catch {
    return unknown;
  }

  return locateCountry(parsed?.country);
}

/**
 * @param {string|null|undefined} country ISO2 code
 * @returns {{ country: string|null, lat: number|null, lng: number|null, precision: string }}
 */
function locateCountry(country) {
  const code = typeof country === "string" ? country.toUpperCase() : null;
  const centroid = code && COUNTRY_CENTROIDS[code];
  if (!centroid) return { country: null, lat: null, lng: null, precision: PRECISION_UNKNOWN };
  return { country: code, lat: centroid[0], lng: centroid[1], precision: PRECISION_COUNTRY };
}

module.exports = { locateNumber, locateCountry, PRECISION_COUNTRY, PRECISION_UNKNOWN };
